import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AurIconConfig, AurIconSize } from '@shared/models/core-component.models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aur-icon',
  standalone: true,
  template: `<span [class]="classes" [attr.aria-hidden]="ariaHidden ? 'true' : null"></span>`,
})
export class AurIconComponent {
  @Input() name = 'circle-outline';
  @Input() size?: AurIconSize;
  @Input() ariaHidden = true;
  @Input() set config(value: AurIconConfig | null | undefined) {
    if (!value) return;
    this.name = value.name ?? this.name;
    this.size = value.size ?? this.size;
    this.ariaHidden = value.ariaHidden ?? this.ariaHidden;
  }

  get classes(): string {
    const parts = ['icon', `icon--${this.name}`];
    if (this.size) parts.push(`icon--${this.size}`);
    return parts.join(' ');
  }
}
